import { Component, EventEmitter, Input, Output } from '@angular/core';
declare var bootstrap: any;

interface ButtonConfig {
  label: string;
  action: string;
  class: string;
}

@Component({
  selector: 'app-ncs-msgbox',
  templateUrl: './ncs-msgbox.component.html',
  styleUrls: ['./ncs-msgbox.component.scss'],
})
export class NcsMsgboxComponent {
  @Input() title: string = 'Message';
  @Input() message: string = 'Please confirm';
  @Input() buttons: ButtonConfig[] = [];

  @Output() onOk = new EventEmitter<void>();
  @Output() onYes = new EventEmitter<void>();
  @Output() onNo = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();

  @Input() cancelLable: string = 'Cancel';
  @Input() okLable: string = 'Yes';

  onButtonClick(action: string) {
    if (action === 'yes') {
      this.onYes.emit();
    } else if (action === 'ok') {
      if (this.onOk.observers.length > 0) {
        this.onOk.emit();
      } else {
        this.defaultOkAction();
      }
    } else if (action === 'no') {
      this.onNo.emit();
    } else if (action === 'cancel') {
      // Check if there are any subscribers to onCancel
      if (this.onCancel.observers.length > 0) {
        this.onCancel.emit();
      } else {
        this.defaultCancelAction();
      }
    }
  }

  // Define the default action for cancel
  private defaultCancelAction() {
    console.log('Default cancel action executed.');
    // Add any default logic for Cancel here
  }
  private defaultOkAction() {
    this.defaultCancelAction();
  }

  ngOnInit() {
    this.openModal();
  }

  openModal() {
    const modalElement = window.document.getElementById('messageBoxModal');
    if (modalElement) {
      new bootstrap.Modal(modalElement).show();
    }
  }
}
